// extracted by mini-css-extract-plugin
module.exports = {"ctaWrapper":"jgp-1FSDI"};